import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group shrink-0"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-shield-star-line text-lg md:text-xl text-background-50"></i>
            </div>
            <span className={`font-heading font-bold text-lg md:text-xl whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            }`}>
              男子汉宝藏
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled ? 'bg-primary-100 text-primary-700' : 'bg-background-50/20 text-background-50'
                  : scrolled ? 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>

            <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
              <button
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? scrolled ? 'bg-primary-100 text-primary-700' : 'bg-background-50/20 text-background-50'
                    : scrolled ? 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {categoryOpen && (
                <div className="absolute top-full left-0 mt-1 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 w-52">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? scrolled ? 'bg-primary-100 text-primary-700' : 'bg-background-50/20 text-background-50'
                  : scrolled ? 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              首页
            </Link>
            <div className="px-4 py-1">
              <p className="text-xs text-foreground-400 font-medium mb-2">分类浏览</p>
              <div className="flex flex-col gap-0.5">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-3 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg transition-colors flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 shrink-0"></span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}